import { isDEVMODE, globalStorage, domStorage, viewStorage } from '../_globals'
import gsap from 'gsap'
import { Observer } from 'gsap/Observer'
gsap.registerPlugin(Observer)

export default class Header {
  constructor() {
    // DOM
    this.DOM = { el: domStorage.header }
    this.DOM.brand = this.DOM.el.querySelector('.Brand')
    this.DOM.open = this.DOM.el.querySelector('.NavToggle')
    this.DOM.close = this.DOM.el.querySelector('.Close')
    this.DOM.menuContainer = this.DOM.el.querySelector('.NavContainer')
    this.DOM.ov = this.DOM.el.querySelector('.ov')

    // Events
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    this.DOM.open.addEventListener('click', this.open)
    this.DOM.close.addEventListener('click', this.close)

    globalStorage.openMobileMenu = () => this.open()
    globalStorage.closeMobileMenu = () => this.close()

    this.setObservers()

    // Resize
    this.resizeTimeout = setTimeout(() => {}, 0)
    this.onResize = this.onResize.bind(this)
    this.windowWidthResize = window.innerWidth
    window.addEventListener('resize', this.onResize)
  }

  open(e) {
    e && e.preventDefault()

    this.tlOpen = gsap.timeline({
      onStart: () => {
        globalStorage.menuOpen = true
        domStorage.body.classList.add('--show-menu')

        // Enable scroll
        this.DOM.menuContainer.setAttribute('data-lenis-prevent', true)

        // Stop the current smooth scroll
        viewStorage.viewScroll.scroll.stop()
      },
      onComplete: () => {
        gsap.set(this.DOM.menuContainer, { clearProps: 'all' })
      }
    })
    .to(this.DOM.ov, { opacity: 1, duration: 0.5 }, 0)
    .from(this.DOM.menuContainer, { yPercent: 50, opacity: 0, scale: 0.8, ease: 'elastic.out(1,0.95)', duration: 0.5 }, 0.2)
  }

  close(e) {
    e && e.preventDefault()

    this.tlClose = gsap.timeline({
      onComplete: () => {
        globalStorage.menuOpen = false
        domStorage.body.classList.remove('--show-menu')

        gsap.set(this.DOM.menuContainer, { clearProps: 'all' })
        gsap.set(this.DOM.ov, { clearProps: 'all' })

        // Restart the smooth scroll
        viewStorage.viewScroll.scroll.start()

        // Disable scroll
        this.DOM.menuContainer.removeAttribute('data-lenis-prevent')
      }
    })
    .to(this.DOM.menuContainer, { yPercent: 50, opacity: 0, scale: 0.8, ease: 'elastic.in(1,0.95)', duration: 0.5 }, 0)
    .to(this.DOM.ov, { opacity: 0, duration: 0.5 }, 0.5)
  }

  setObservers() {
    const { el } = this.DOM

    this.onScrollObserver = Observer.create({
      target: window,
      type: 'scroll',
      tolerance: 0,
      onUp: (self) => {
        el.classList.remove('--hide')

        if (self.scrollY() <= 20) el.classList.remove('--scroll')
      },
      onDown: (self) => {
        !el.classList.contains('--hide') && el.classList.add('--hide')

        self.scrollY() > 20 && !el.classList.contains('scroll') && el.classList.add('--scroll')
      },
    })
  }

  onResize() {
    clearTimeout(this.resizeTimeout)

    this.resizeTimeout = setTimeout(() => {
      if (this.windowWidthResize !== window.innerWidth) {
        // if (isDEVMODE) console.log('updateHeaderResize')
        this.windowWidthResize = window.innerWidth
        if (globalStorage.menuOpen === true) this.close()
      }
    }, 250)
  }
}
